import { initializeApp, type FirebaseApp } from "firebase/app";
import { getFirestore, type Firestore } from "firebase/firestore";
import { getAuth, type Auth } from "firebase/auth";
import { getFunctions, type Functions } from "firebase/functions";
import { getDatabase, type Database } from "firebase/database";

const firebaseConfig: {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
} = {
  apiKey: "AIzaSyD-fGjedaf9nPrUiw9Tp-Xnm1DX-iNtsJs",
  authDomain: "worshipr-179614.firebaseapp.com",

  // Realtime Database URL
  databaseURL: "https://worshipr-179614.firebaseio.com",

  projectId: "worshipr-179614",
  storageBucket: "worshipr-179614.appspot.com",
  messagingSenderId: "748131721602",
  appId: "1:748131721602:web:26f14d524e80ad039aaf9b",
};

const app: FirebaseApp = initializeApp(firebaseConfig);

const auth: Auth = getAuth(app);
const db: Firestore = getFirestore(app);
const realtimeDb: Database = getDatabase(app);
const functions: Functions = getFunctions(app, "europe-west1");

export { app, auth, db, realtimeDb, functions };
